import styled from '@emotion/styled/macro';

export const IconContainer = styled.div`
  align-self: flex-start;
`;
